(function() {
    "use strict";
    
    if (!Array.prototype.sortBy) {
        var sorter = function(alpha, bravo) {
            var alphaKey = alpha.key;
            var bravoKey = bravo.key;
            if (alphaKey < bravoKey) {
                return -1;
            } else if (alphaKey > bravoKey) {
                return 1;
            } else {
                return 0;
            }
        }

        Array.prototype.sortBy = function(selector) {
            var length = this.length;
            for (var i = 0; i < length; i++) {
                var value = this[i];
                this[i] = {
                    value: value,
                    key: selector(value)
                };
            }
            this.sort(sorter);
            for (var i = 0; i < length; i++) {
                this[i] = this[i].value;
            }
        };
    };
})();



// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/Array.sortBy.js